import { Flex } from '@chakra-ui/react';
import { Card, CardBody, CardHeader } from 'ui-components';

import { SkeletonColored } from '../MyAgency/components/StackView/CreatorSkeleton';

export const CustomShareableCardSkeleton = () => {
  return (
    <Card borderRadius={'24px'}>
      <CardHeader marginBottom={2}>
        <SkeletonColored height="120px" borderRadius="lg" />
      </CardHeader>
      <CardBody>
        <Flex>
          <SkeletonColored height="16px" width="180px" marginBottom={2} />
        </Flex>
        <Flex align="center" justifyContent="space-between" marginBottom={5}>
          <SkeletonColored height="12px" width="60px" />
          <SkeletonColored height="8px" width="40px" />
        </Flex>
        <Flex gap={2}>
          <SkeletonColored height="40px" flex={1} />
        </Flex>
      </CardBody>
    </Card>
  );
};
